<pmv-fieldset [header]="header" *ngIf="header; else nofieldset">
  <ng-container *ngTemplateOutlet="dateInterval"></ng-container>
</pmv-fieldset>

<ng-template #nofieldset>
  <ng-container *ngTemplateOutlet="dateInterval"></ng-container>
</ng-template>

<ng-template #dateInterval>
  <div class="date-interval">
    <label *ngIf="label">{{ label }}</label>
    <p-calendar #initialDate [(ngModel)]="dataInicial" inputStyleClass="form-control" dateFormat="dd/mm/yy" [showIcon]="false"
      [minDate]="minDate" [maxDate]="value && value.length == 2 ? value[1] : ''" [disabledDates]="disabledDates" [disabledDays]="disabledDays"
      [locale]="pt" hourFormat="24" (onSelect)="onSelectInitial($event)" [disabled]="disabled" [inputId]="identifier + 'i'"></p-calendar>
    a
    <p-calendar #finalDate [(ngModel)]="dataFinal" inputStyleClass="form-control" dateFormat="dd/mm/yy" [showIcon]="false" [minDate]="value && value.length == 2 ? value[0] : ''"
      [maxDate]="maxDate" [disabledDates]="disabledDates" [disabledDays]="disabledDays" [locale]="pt" hourFormat="24" (onSelect)="onSelectFinal($event)"
      [disabled]="disabled || (initialRequiredForFinal && !dataInicial)" [inputId]="identifier + 'f'"></p-calendar>
  </div>
</ng-template>



// WEBPACK FOOTER //
// ./src/deps/pmv-common/pmv-common.d.ts.ɵw.html